import { render } from "./TrfNumberInput.vue?vue&type=template&id=229e556e&scoped=true"
import script from "./TrfNumberInput.vue?vue&type=script&lang=js"
export * from "./TrfNumberInput.vue?vue&type=script&lang=js"

import "./TrfNumberInput.vue?vue&type=style&index=0&id=229e556e&lang=scss&scoped=true"

import exportComponent from "/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-229e556e"],['__file',"src/components/Input/TrfNumberInput.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "229e556e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('229e556e', __exports__)) {
    console.log('reload')
    api.reload('229e556e', __exports__)
  }
  
  module.hot.accept("./TrfNumberInput.vue?vue&type=template&id=229e556e&scoped=true", () => {
    console.log('re-render')
    api.rerender('229e556e', render)
  })

}


export default __exports__